/**
 * External dependencies
 */
import { isEmpty, isObject, identity, mapValues, pickBy } from 'lodash';
/**
 * Removed empty nodes from nested objects.
 *
 * @param {Object} object
 * @return {Object} Object cleaned from empty nodes.
 */

const cleanEmptyObject = object => {
  if (!isObject(object) || Array.isArray(object)) {
    return object;
  }

  const cleanedNestedObjects = pickBy(mapValues(object, cleanEmptyObject), identity);
  return isEmpty(cleanedNestedObjects) ? undefined : cleanedNestedObjects;
};

export default cleanEmptyObject;
//# sourceMappingURL=clean-empty-object.js.map